import i18n from 'i18next';
import { initReactI18next, TFunction } from 'react-i18next';

import translationEN from './locales/en/translationEN.json';
import translationDE from './locales/de/translationDE.json';
import { Languages } from './scripts/core/enums/Languages';

// eslint-disable-next-line import/no-mutable-exports
let translate: TFunction<string>;
const resources = {
  'en-EN': {
    translation: translationEN
  },
  'de-DE': {
    translation: translationDE
  }
};

i18n.use(initReactI18next).init(
  {
    resources,
    lng: sessionStorage.getItem('i18nextLng') || Languages.De,
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  },
  (err, t) => {
    translate = t;
  }
);

export { translate as t };

export default i18n;
